import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import store from 'store';

import Config from './Config.js';

class ForgetPasswordChangePW extends Component {

  constructor(props){
    super(props);

    this.state = {
      password : '',
      passwordRetype : '',
      next : ''
    }

    this.createPassword = this.createPassword.bind(this);

  }

  componentDidMount(){
    if(this.props.location.token === undefined){
      this.setState({next: 'login'});
    }
  }

  createPassword(){

    if(this.state.password !== ''){
      if( this.state.password === this.state.passwordRetype){
        let url = Config.SERVER_URL + Config.API_SETPASSWORD +'?token='+ this.props.location.token + '&password='+ this.state.password;

        fetch(url, {
           method: 'POST',
           headers: {
             'Accept': 'application/json',
             'Content-Type': 'application/json',
           },
        })
        .then((response) =>     response.json())
        .then((responseJson) => {

          if(responseJson.Result){

            store.set(Config.TOKEN, this.props.location.token);
            this.setState({next : 'resultlist'});

          }else{
            alert(responseJson.ResultMessage);
          }

        })
        .catch((error) => {

        });
      }else{
        alert("The password doesn’t match.\n รหัสผ่านไม่ตรงกัน");
      }
    }else{
      alert("Please set your password.\n กรุณาตั้งรหัสผ่าน");
    }
  }

  render() {

    if(this.state.next === 'resultlist'){
      return <Redirect to={{
        pathname: '/resultlist',
        token: this.state.token}}
      />;
    }else if (this.state.next === 'login' ){
      return <Redirect to='/login'/>
    }

    return(
      <div className='container' style={{backgroundColor: 'rgb(220, 224, 239)'}}>
        <div style={{height:80}}>
        </div>
        <div className="row">

          <div className="col-md-4 col-md-offset-4" style={{backgroundColor: 'white' , textAlign:'center' , borderRadius: 5,paddingLeft: 0 , paddingRight:0 }}>

            <div style={{ padding: 15,backgroundColor: 'rgb(68 ,53 ,109)' ,height:60}}>
              <font style={{color:'white',textAlign: 'center'}}><h5>SET PASSWORD</h5></font>
            </div>

            <div style={{height:16}} />

            <img src={require('../assets/img/logo.png')} alt="new password"
              style={{width:231 ,height:78}} />

            <div style={{height:24}} />

            <h6>Password</h6>

            <div style={{height:4}} />

            <input type="password" placeholder="Password"
              style={{borderRadius:4,width:314 ,height:37 ,
                paddingLeft: 10, paddingRight:10 ,
                backgroundColor:'rgb(236 ,240 ,241)'}}
              value={this.state.password}
              onChange={(event) => { this.setState({password :event.target.value })}}
              />

            <div style={{height:27}} />

            <h6>Confirm password</h6>

            <div style={{height:5}} />

            <input type="password" placeholder="Retype Password"
              style={{borderRadius:4,width:314 ,height:37 ,
                paddingLeft: 10, paddingRight:10 ,
                backgroundColor:'rgb(236 ,240 ,241)'}}
              value={this.state.passwordRetype}
              onChange={(event) => { this.setState({passwordRetype :event.target.value })}}
              />

            <div style={{height:32}} />

            <button onClick={this.createPassword}
              style={{height: 49,width:315, borderRadius: 4,color: 'white',background: "linear-gradient(#41b9ce, #58488b)"}}>
              CONFIRM
            </button>

            <div style={{height: 20}}/>

          </div>
        </div>
      </div>
    );
  }
}

export default ForgetPasswordChangePW;



// WEBPACK FOOTER //
// ./src/components/ForgetPasswordChangePW.js